import React from 'react';
import { Spinner } from '../spinner/Spinner';
import { useLoading } from '../../../contexts/LoadingContext';

/**
 * Shows when loading is occuring. Works with the Loading Context
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI 
 */
export const LoadingDialog = () => {
    const {isLoading, loadingMessage, blurBGCont} = useLoading();

    if(!isLoading) return null;

    return (
        <>
            {blurBGCont &&
                <div className={`h-screen w-screen fixed inset-0 z-[22] transition-opacity opacity-75 bg-black bg-opacity-50 backdrop-filter backdrop-blur-md`}></div>
            }
            <div className='fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-30 bg-white p-5 opacity-75 rounded-md border border-black' role="status">
                <Spinner className="text-center"/>
                <h1 className='text-center font-Poppins-Med mt-3 italic text-tcbGreen'>{loadingMessage}</h1>
            </div>
        </>
    )
}